<template>
  <div>
    <v-select
      v-model="state.componenteData.opcaoSelecionada"
      dense
      outlined
      no-data-text="Nenhum item registrado"
      item-text="nome"
      item-value="id"
      hide-details
      :label="state.componenteData.label"
      :items="state.componenteData.opcoes"
      :disabled="disabled"
      :filled="filled"
      readonly
      :rules="[(state.componenteData.obrigatorio ? val => !!val || 'Este campo é obrigatório' : true)]"
      @change="resetarSelectsSubsequentes(state.componenteData)"
      @input="v => $emit('adicionar-formulario-resposta', { selecionado: state.componenteData.opcaoSelecionada, id: state.componenteData.id })"
    >
      <template
        v-if="mostrarIcones"
        v-slot:prepend
      >
        <icons
          :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
          :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
          @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
          @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
        />
      </template>
    </v-select>

    <v-select
      v-for="(encadeado, index) in encadeados"
      :key="encadeado.id"
      v-model="encadeado.opcaoSelecionada"
      class="mt-2"
      dense
      outlined
      no-data-text="Nenhum item registrado"
      item-text="nome"
      item-value="id"
      hide-details
      :label="encadeado.label"
      :items="filtrarOpcoes(encadeado, index)"
      :disabled="disabled"
      :filled="filled"
      readonly
      :rules="[(encadeado.obrigatorio ? val => !!val || 'Este campo é obrigatório' : true)]"
      @change="resetarSelectsSubsequentes(encadeado, index)"
      @input="v => $emit('adicionar-formulario-resposta', { selecionado: encadeado.opcaoSelecionada, id: encadeado.id })"
    >
      <template
        v-if="mostrarIcones"
        v-slot:prepend
      >
        <v-icon
          color="accent"
          class="pl-4 pr-3"
        >
          {{ icons.mdiLinkVariant }}
        </v-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiLinkVariant } from '@mdi/js'
import Componente from '@/models/entities/formulario/componente/Componente'
import Icons from '@/views/formulario/componentes/Icons.vue'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'
import ComponenteBase from '@/views/formulario/componentes/ComponenteBase.vue'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  setup(props) {
    const state = ref({})
    const encadeados = ref([])

    function setOpcaoSelecionda(item) {
      const tamanho = item.ticketsRespostas.length
      const idResposta = item.ticketsRespostas[tamanho - 1]

      return idResposta ? idResposta.idFormularioElementoOpcaoResposta : 0
    }

    function setData(value) {
      state.value = { componenteData: value, opcaoSelecionada: 0 }
      encadeados.value = Componente.listarComponentesEncadeados(state.value.componenteData.elementoEncadeado)

      state.value.componenteData.opcaoSelecionada = setOpcaoSelecionda(state.value.componenteData)

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < encadeados.value.length; i++) {
        encadeados.value[i].opcaoSelecionada = setOpcaoSelecionda(encadeados.value[i])
      }
    }

    watch(() => props.componenteData, setData, { immediate: true, deep: true })

    function filtrarOpcoes(encadeado, index) {
      const encadeadoPai = index === 0 ? state.value.componenteData : encadeados.value[index - 1]

      return !encadeadoPai.opcaoSelecionada ? [] : encadeado.opcoes.filter(op => op.idOpcaoPai === encadeadoPai.opcaoSelecionada)
    }

    function resetarSelectsSubsequentes(elemento, index) {
      if (elemento.idElementoPai === null) {
        encadeados.value = encadeados.value.map(it => ({ ...it, opcaoSelecionada: 0 }))
      } else {
        encadeados.value = encadeados.value.map((it, ind) => (ind > index ? { ...it, opcaoSelecionada: 0 } : it))
      }
    }

    return {
      state,
      encadeados,
      filtrarOpcoes,
      resetarSelectsSubsequentes,
      icons: {
        mdiLinkVariant,
      },
      TiposDeComponentesEnum,
    }
  },
}
</script>
